<template>
    <v-layout fluid fill-height>
        <v-flex row wrap>
            <v-card min-height="100px" min-width="100px" height="100%" v-if="!this.division">
                <v-progress-linear
                    indeterminate
                ></v-progress-linear>
            </v-card>
            <v-card min-height="100px" min-width="100px" height="100%" v-else>
                <v-card-title class="upload-title">
                    <h2>Upload Map Data - {{ this.division.DivisionName }}</h2>
                </v-card-title>
                <v-card-text>
                    <input type="file" accept=".kml" ref="fileInput" @change="handleFileChange" :disabled="this.uploading"/>
                </v-card-text>
                <v-btn color="success" :disabled="this.uploadDisabled || this.uploading" @click="uploadFile">
                    <v-icon left>cloud_upload</v-icon>
                    Upload
                </v-btn>
                <v-card-text class="upload-indicator" v-if="this.uploading">
                    <v-progress-circular indeterminate />
                </v-card-text>
                <v-alert :value=this.errorMessage color="error" icon="warning" outline>
                    {{ this.errorMessage }}
                </v-alert>
                <v-alert :value=this.responseMessage color="success" icon="check_circle" outline>
                    {{ this.responseMessage }}
                </v-alert>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import divisionApi from '../../api/divisionApi'

export default {
    props: ['alerts'],
    data() {
        return {
            selectedFile: null,
            uploadDisabled: true,
            uploading: false,
            responseMessage: null,
            errorMessage: null,
            division: null,
        };
    },
    methods: {
        async handleFileChange(event) {
            const file = event.target.files[0];

            if (file) {
                this.selectedFile = file;
                this.uploadDisabled = false;
            } else {
                this.resetForm();
            }
        },
        async uploadFile() {
            const reader = new FileReader();

            reader.onload = async (e) => {                    
                this.uploading = true;

                const fileAsString = e.target.result;
                const response = await divisionApi.addDivisionData(this.division.DivisionID, fileAsString);

                if (response.Success) {
                    this.responseMessage = "Division data uploaded successfully.";
                } else {
                    this.errorMessage = response.ErrorMessage;
                }

                this.selectedFile = null;
                this.uploadDisabled = true;
                this.uploading = false;
            }

            reader.readAsText(this.selectedFile);
        },
        resetForm() {
            this.selectedFile = null,
            this.uploadDisabled = true,
            this.uploading = false;
            this.responseMessage = null;
            this.errorMessage = null;
        }
    },
    async mounted() {
        this.resetForm();
        let divisionID = this.$route.params.DivisionID
        if (divisionID) {
            this.division = await divisionApi.getDivision(divisionID);
        }
    }
}
</script>

<style>

.upload-title {
    background-color: #c1dd88;
}

.upload-indicator {
    text-align: center;
}

</style>
